import type { Token, UserLogin } from '@features/user-access';

import Routing from '@core/api/routing';
import { baseApi } from '@core/api/base-api';

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<Token, UserLogin>({
      query: (userLogin) => ({
        url: Routing.generate('api_login_check', {}, true),
        method: 'POST',
        body: userLogin,
      }),
    }),
    ip: builder.query<void, string>({
      query: (ip) => ({
        url: Routing.generate('rest_user_ip', {}, true),
        method: 'POST',
        body: { ip },
      }),
    }),
  }),
});

export const { useLoginMutation, useIpQuery } = authApi;
